import { Layout } from 'components/layout'
import { Header } from './header'
import { Timeline } from './timeline'

export const Home = () => {
  return (
    <Layout>
      <Header />
      <Timeline />
    </Layout>
  )
}
